import { render, staticRenderFns } from "./OmnicaTask.vue?vue&type=template&id=c031f7b4&scoped=true"
import script from "./OmnicaTask.vue?vue&type=script&lang=js"
export * from "./OmnicaTask.vue?vue&type=script&lang=js"
import style0 from "./OmnicaTask.vue?vue&type=style&index=0&id=c031f7b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c031f7b4",
  null
  
)

export default component.exports